import React, { Component } from 'react'

export class CommentItem extends Component {
   render() {
      return (
         <div className='comment_item'>
            <div className="user_box">
               <img src={"./img/commentsImg/" + this.props.item.foto} />
               <div className="user_details">
                  <span className='name'>{this.props.item.name}</span>
                  <span className='country'>{this.props.item.country}</span>
               </div>
            </div>
            <div className="comment_text">
               {this.props.item.comment}
            </div>
         </div>
      )
   }
}

export default CommentItem
